
import { createSlice } from "@reduxjs/toolkit";

const CheckselectedIndicatorsSlice = createSlice({
  name: "CheckselectedIndicators",
  initialState: {
    items: [] 
  },
  reducers: {
    toggleIndicator: (state, action) => {
      const ind = action.payload;
      const exists = state.items.some(
        (item) => item.indicator_code === ind.indicator_code
        && item?.sub_indicator_code === ind.sub_indicator_code
      );
      if (exists) {
        // remove
        state.items = state.items.filter(
          (item) => item.indicator_code !== ind.indicator_code
          && item?.sub_indicator_code !== ind.sub_indicator_code
        );
      } else {
        // add
        state.items.push({
          indicator_code: ind.indicator_code,
          sub_indicator_code: ind.sub_indicator_code,
          indicatordata:ind
        });
      }
    },
    clearIndicators: (state) => {
      state.items = [];
    }
  }
});

export const { toggleIndicator, clearIndicators } = CheckselectedIndicatorsSlice.actions;
export default CheckselectedIndicatorsSlice.reducer;
